import { Component } from '@angular/core';
import { AppPermission } from '@app/shared/services/apps/apps.service';

@Component({
  standalone: false,
  selector: 'sbnb-pricelabs',
  template: `
    <sbnb-apps-detail-page
      vendorCode="pricelabs"
      name="PriceLabs"
      builtBy="PriceLabs"
      [categories]="['Dynamic pricing']"
      [permissions]="[
        AppPermission.propertyListingRead,
        AppPermission.enrichmentRead,
        AppPermission.financialsRead,
        AppPermission.calendarRead,
        AppPermission.calendarPartialWrite
      ]"
      email="support@pricelabs.co"
      logoTile="/assets/images/apps/pricelabs.svg"
      [helpArticles]="[
        {
          id: '4596787',
          title: 'How do I integrate with PriceLabs?'
        }
      ]">
      <ng-container description>
        <div class="space-y-4">
          <p>
            PriceLabs is a powerful revenue management tool that takes the guesswork out of pricing. It tracks data from
            Airbnb, VRBO, and Booking.com to build precise price recommendations for each property. Its Hyper Local
            Pulse algorithm optimizes prices by automatically considering seasonality, events, holidays, lead time, and
            day-of-week trends. With its extensive customizations, you can control your prices to suit all needs.
          </p>

          <p>
            It automatically updates prices on the preferred booking platform using the Hospitable integration. This
            frees you from the hassle of constant monitoring and adjustments.
          </p>

          <p>
            Built for hosts & property managers of all sizes, PriceLabs considers the latest market data to maximize
            your income while saving you time.
          </p>

          <p><strong>Why Use PriceLabs?</strong></p>

          <ul class="space-y-3 list-disc pl-5 leading-normal">
            <li>
              <span class="strong">Maximize Revenue:</span>
              Intelligent algorithms provide data-driven price recommendations by analyzing market supply, demand,
              seasonal trends, special events, and booking lead time.
            </li>

            <li>
              <span class="strong">Stay in Control:</span>
              Customize daily prices and dynamic minimum stays to fit your strategy. Create comp sets to compare with
              similar properties and benchmark with hotel prices.
            </li>

            <li>
              <span class="strong">Make Confident Decisions:</span>
              Use precise, hyperlocal market data to back your pricing decisions.
            </li>

            <li>
              <span class="strong">Save Time:</span>
              Enjoy intuitive workflows, bulk updates, AI Insights and advanced portfolio analytics.
            </li>

            <li>
              <span class="strong">Discover Earning Potential:</span>
              Revenue Estimator Pro offers instant revenue estimates, helping you make informed decisions quickly.
            </li>
          </ul>
        </div>

        <sbnb-image-carousel
          [autoCycle]="true"
          [images]="[
            '/assets/images/apps/pricelabs/1.png',
            '/assets/images/apps/pricelabs/2.png',
            '/assets/images/apps/pricelabs/3.png'
          ]"></sbnb-image-carousel>
      </ng-container>
    </sbnb-apps-detail-page>
  `,
})
export class PricelabsComponent {
  AppPermission = AppPermission;
}
